import '../scss/artwood.scss';

import wpBlockFunctionality from './modules/blocks';
import cartFunctionality from './modules/cart';
import checkoutPageFunctionality from './modules/checkout';
import complaintForm from './modules/complaint';
import generalShopFunctionality from './modules/general';
import guestFunctionality from './modules/guests';
import headerFunctionality from './modules/header';
import iframesFunctionality from './modules/iframe';
import languagePickerFunctionality from './modules/language';
import menuFunctionality from './modules/menu';
import productListFunctionality from './modules/product-list';
import productPageFunctionality from './modules/product-page';
import searchFunctionality from './modules/search';
import initSlickSliders from './modules/slick-sliders';
import categoryPageFunctionality from './modules/category-page';
import startpageFunctionality from './modules/start-page';
import mobileMenuFunctionality from './modules/mobile-menu';
import languageSelectorFunctionality from './modules/language-selector';

jQuery(document).ready(function (jQuery) {
  startpageFunctionality();
  productPageFunctionality();
  productListFunctionality();
  iframesFunctionality();
  guestFunctionality();
  initSlickSliders();
  cartFunctionality();
  complaintForm();
  languagePickerFunctionality();
  checkoutPageFunctionality();
  generalShopFunctionality();
  searchFunctionality();
  headerFunctionality();
  wpBlockFunctionality();
  categoryPageFunctionality();
  menuFunctionality();
  removeUpSellFromGallery();
  mobileMenuFunctionality();
  languageSelectorFunctionality();
  moveResellerLink();
  semestertider();
});

function removeUpSellFromGallery() {
  const amountOfUpSells = jQuery('.woocommerce-product-gallery__wrapper img.upsell-image').length;
  if (amountOfUpSells > 0) {
    jQuery('.woocommerce-product-gallery__wrapper img.upsell-image').each(function () {
      jQuery(this).closest('.woocommerce-product-gallery__image').remove();
    });

    // jQuery('.flex-control-nav').remove();
    // jQuery('.woocommerce-product-gallery').removeData('flexslider');
    // jQuery('.woocommerce-product-gallery').wc_product_gallery();
    // jQuery('.flex-viewport').eq(0).hide();
    // setInterval(function(){
    //   if (jQuery('.pswp--open').length && jQuery('.pswp--open').css('position') != 'fixed') {
    //     const jQueryelement = jQuery('.pswp--open');
    //     jQueryelement.removeClass();
    //     jQueryelement.addClass('pswp');
    //   }
    // }, 200);
  }
}

function moveResellerLink() {
  const resellerLink = jQuery('#guest-reseller-link');
  if (resellerLink.length > 0 && jQuery('.summary.entry-summary form').length == 1) {
    resellerLink.appendTo(jQuery('.summary.entry-summary form'));
    resellerLink.addClass('wl-moved');
    resellerLink.show();
  }
}

function semestertider() {
  if (jQuery('.cart-header').length & jQuery('.shop_table').length) {
    if (new Date(current_timestamp) >= new Date('2024-12-16 06:00:00') && new Date(current_timestamp) <= new Date('2025-01-02 06:00:00')) {
      const text = jQuery('html').attr('lang') == 'sv-SE' ? '<style>@media (min-width:1000px) {.semestertider {display:flex; text-align: center;}}</style><p style="margin:5px 0;font-weight:bold;">Öppettider och Leveranser</p><p style="margin:5px 0;">Stängt 23 dec–2 jan. Leveranser återupptas från vecka 3.</p><p style="margin:5px 0;">God jul och gott nytt år!</p>' : '<p style="margin:5px 0;font-weight:bold;">Opening Hours and Deliveries</p><p style="margin:5px 0;">Closed Dec 23–Jan 2. Deliveries resume from week 3.</p><p style="margin:5px 0;">Merry Christmas and Happy New Year!</p>';
      jQuery('.shop_table').append('<div class="semestertider" style="gap: 5px; justify-content: center; margin-top: 20px; font-size: 20px;">' + text + '</div>');
    }
  }
}
